import {useCallback} from 'react';

const shouldPreventRestrictDecimal = (key, currentValue) => {
  return ['.', ',', 'e', '-'].includes(key) || (!currentValue && key === '0');
};

const handleNumberKeyDown = (e, currentValue, maxLength) => {
  const {key} = e;
  const inputElement = e.target;

  if (['e', 'E', '+', '-', ','].includes(key)) {
    e.preventDefault();
    return;
  }

  if (['ArrowUp', 'ArrowDown'].includes(key)) {
    e.preventDefault();
    return;
  }

  if (!/^\d$/.test(key)) {
    return;
  }

  const selectionLength =
    inputElement.selectionEnd - inputElement.selectionStart;
  if (maxLength && currentValue.length >= maxLength && selectionLength === 0) {
    e.preventDefault();
    return;
  }

  const decimalIndex = currentValue.indexOf('.');
  if (decimalIndex === -1) {
    return;
  }

  const decimalPlaces = currentValue.substring(decimalIndex + 1).length;
  if (decimalPlaces >= 2) {
    e.preventDefault();
  }
};

export function useNumberKeyDown(schema, maxLength) {
  const handleKeyDown = useCallback(
    (e) => {
      const {key} = e;
      const inputElement = e.target;
      const currentValue = inputElement ? inputElement.value : '';

      if (schema?.restrictDecimal) {
        if (shouldPreventRestrictDecimal(key, currentValue)) {
          e.preventDefault();
        }
      } else if (schema?.type === 'number') {
        handleNumberKeyDown(e, currentValue, maxLength);
      }
    },
    [schema?.restrictDecimal, schema?.type, maxLength]
  );

  return handleKeyDown;
}
